import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=209db4b7&scoped=true"
import script from "./forum.vue?vue&type=script&lang=js"
export * from "./forum.vue?vue&type=script&lang=js"
import style0 from "./forum.vue?vue&type=style&index=0&id=209db4b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209db4b7",
  null
  
)

export default component.exports